import {
  getAuctionImpugnations,
  createAuctionImpugnation,
  answerAuctionImpugnation,
} from '@/resources/electronicAuctions/auctionsImpugnations';
import { rejectManifestacaoRequest, findManifestacaoIndex } from '@/utils/manifestacaoError';

const types = {
  IMPUGNATION_RESPONSE: 'IMPUGNATION_RESPONSE',
  IMPUGNATION_UPDATE: 'IMPUGNATION_UPDATE',
  IMPUGNATIONS: 'IMPUGNATIONS',
};

const normalizeImpugnation = impugnation => {
  const impugnationClone = { ...impugnation };

  impugnationClone.createdAt = new Date(impugnation.createdAt);
  impugnationClone.anexos = Array.isArray(impugnation.anexos) ? impugnation.anexos : [];
  impugnationClone.anexosResposta = Array.isArray(impugnation.anexosResposta)
    ? impugnation.anexosResposta
    : [];

  if (impugnationClone.response?.date) {
    impugnationClone.response.date = new Date(impugnationClone.response.date);
  }

  return impugnationClone;
};

const preserveAnexos = (atual, atualizado) => {
  let next = { ...atualizado };

  if (!next.anexos.length && atual?.anexos?.length) {
    next = { ...next, anexos: atual.anexos };
  }

  if (!next.anexosResposta?.length && atual?.anexosResposta?.length) {
    next = { ...next, anexosResposta: atual.anexosResposta };
  }

  return next;
};

const mutations = {
  [types.IMPUGNATIONS](state, impugnations) {
    if (impugnations && Array.isArray(impugnations)) {
      state.impugnations = impugnations.map(normalizeImpugnation);
    }
  },
  [types.IMPUGNATION_RESPONSE](state, impugnation) {
    if (impugnation && typeof impugnation === 'object') {
      const index = findManifestacaoIndex(state.impugnations, impugnation);
      const normalized = preserveAnexos(
        index > -1 ? state.impugnations[index] : null,
        normalizeImpugnation(impugnation),
      );

      if (index > -1) {
        state.impugnations.splice(index, 1, normalized);
      } else {
        state.impugnations.unshift(normalized);
      }
    }
  },
  [types.IMPUGNATION_UPDATE](state, impugnation) {
    if (impugnation && typeof impugnation === 'object') {
      const normalized = normalizeImpugnation(impugnation);
      const index = findManifestacaoIndex(state.impugnations, normalized);
      if (index > -1) {
        state.impugnations.splice(index, 1, preserveAnexos(state.impugnations[index], normalized));
      } else {
        state.impugnations.unshift(normalized);
      }
    }
  },
};

const actions = {
  async answerAuctionImpugnation({ commit }, { auctionId, impugnationId, data }) {
    const response = await answerAuctionImpugnation(auctionId, impugnationId, data);
    if (response.status !== 200) return rejectManifestacaoRequest(response);
    commit(types.IMPUGNATION_RESPONSE, response.data);
    return response.data;
  },
  async createAuctionImpugnation({ commit }, { auctionId, data }) {
    const response = await createAuctionImpugnation(auctionId, data);
    if (response.status !== 201) return rejectManifestacaoRequest(response);
    commit(types.IMPUGNATION_UPDATE, response.data);
    return response.data;
  },
  async getAuctionImpugnations({ commit }, ofertaCompraId) {
    const response = await getAuctionImpugnations(ofertaCompraId);
    if (response.status !== 200) return rejectManifestacaoRequest(response);
    return commit(types.IMPUGNATIONS, response.data);
  },
  updateAuctionImpugnations({ commit }, impugnation) {
    commit(types.IMPUGNATION_UPDATE, impugnation);
  },
};

const state = {
  impugnations: [],
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
